import { Button } from 'appkit-react';

import { downloadFRY9CTemplate } from '../../../../actions';
import folder from '../../../../assets/images/folder.svg';
import files from '../../../../assets/images/files.svg';
import downloadIcon from '../../../../assets/images/download-small.svg';

const FRY9CUploadTabTwo = () => (
    <div className="true-comply-upload__steptwo-body">
        <div className="true-comply-upload__steptwo-body-dec-section">
            <div className="true-comply-upload__steptwo-body-dec-section-left">
                <div className="true-comply-upload__steptwo-body-dec-section-left-title"> Download the sample template for uploading files </div>
                <Button
                    className="true-comply-upload__steptwo-head-right-btn"
                    onClick={() => downloadFRY9CTemplate()}
                    aria-hidden="true"
                    data-testid="btn-download"
                >
                    Download
                </Button>
            </div>
            <div className="true-comply-upload__steptwo-body-dec-section-right">
                <img src={downloadIcon} alt="Download Icon" />
            </div>
        </div>
        <div className="true-comply-upload__steptwo-body-dec-section">
            <div className="true-comply-upload__steptwo-body-dec-section-left">
                <div className="true-comply-upload__steptwo-body-dec-section-left-title">  Files must be in a .csv format  </div>
                <p className="true-comply-upload__steptwo-body-dec-section-left-subtext">If you received the files in a .zip, please uncompress your files before uploading.</p>
            </div>
            <div className="true-comply-upload__steptwo-body-dec-section-right">
                <img src={folder} alt="Folder Icon" />
            </div>
        </div>
        <div className="true-comply-upload__steptwo-body-dec-section">
            <div className="true-comply-upload__steptwo-body-dec-section-left">
                <div className="true-comply-upload__steptwo-body-dec-section-left-title"> File names are unmodified </div>
                <p
                    className="true-comply-upload__steptwo-body-dec-section-left-subtext"
                >
                    To prevent any issues with diagnostics, please do NOT modify the file names. File names should resemble this structure:
                </p>
                <p className="true-comply-upload__steptwo-body-dec-section-left-subtext">Report_Name_Quarter Period (Q1, Q2, Q3, Q4)_YYYY</p>
            </div>
            <div className="true-comply-upload__steptwo-body-dec-section-right">
                <img src={files} alt="Files Icon" />
            </div>
        </div>
    </div>
);

export default FRY9CUploadTabTwo;
